module.exports = __webpack_public_path__ + "img/share-screen.0e48701e.jpg";